import { DEFAULT_ICON_PATH, sharedIconPaths } from "./shared-icon-paths"

// Section IMDF category icon paths.
// Categories with a matching amenity icon have that SVG path duplicated here
// (replace with section-specific art when available).
// Categories without a dedicated icon use DEFAULT_ICON_PATH as placeholder.
export const sectionIconPaths: Record<string, string> = {
  "section.arcade": DEFAULT_ICON_PATH,
  "section.baggageclaim": DEFAULT_ICON_PATH,
  "section.baggageclaim.intl": DEFAULT_ICON_PATH,
  "section.carrental": DEFAULT_ICON_PATH,
  "section.carrental.dropoff": DEFAULT_ICON_PATH,
  "section.checkin": DEFAULT_ICON_PATH,
  "section.concessions": DEFAULT_ICON_PATH,
  "section.cubicle": DEFAULT_ICON_PATH,
  "section.dutyfree": DEFAULT_ICON_PATH,
  "section.eatingdrinking": DEFAULT_ICON_PATH,
  "section.entertainmentarea": DEFAULT_ICON_PATH,
  "section.entertainmentarea.game": DEFAULT_ICON_PATH,
  "section.entertainmentarea.music": DEFAULT_ICON_PATH,
  "section.entertainmentarea.performance": DEFAULT_ICON_PATH,
  "section.entertainmentarea.sport": DEFAULT_ICON_PATH,
  "section.exhibit": sharedIconPaths["exhibit"],
  "section.exhibition": DEFAULT_ICON_PATH,
  "section.gambling": DEFAULT_ICON_PATH,
  "section.gambling.baccarat": DEFAULT_ICON_PATH,
  "section.gambling.bingo": DEFAULT_ICON_PATH,
  "section.gambling.blackjack": DEFAULT_ICON_PATH,
  "section.gambling.craps": DEFAULT_ICON_PATH,
  "section.gambling.keno": DEFAULT_ICON_PATH,
  "section.gambling.mahjong": DEFAULT_ICON_PATH,
  "section.gambling.medalgame": DEFAULT_ICON_PATH,
  "section.gambling.minibaccarat": DEFAULT_ICON_PATH,
  "section.gambling.offtrackbetting": DEFAULT_ICON_PATH,
  "section.gambling.pachinko": DEFAULT_ICON_PATH,
  "section.gambling.paigow": DEFAULT_ICON_PATH,
  "section.gambling.poker": DEFAULT_ICON_PATH,
  "section.gambling.poker.letitride": DEFAULT_ICON_PATH,
  "section.gambling.poker.paigow": DEFAULT_ICON_PATH,
  "section.gambling.poker.threecard": DEFAULT_ICON_PATH,
  "section.gambling.poker.video": DEFAULT_ICON_PATH,
  "section.gambling.roulette": DEFAULT_ICON_PATH,
  "section.gambling.rummy": DEFAULT_ICON_PATH,
  "section.gambling.sicbo": DEFAULT_ICON_PATH,
  "section.gambling.slotmachine": DEFAULT_ICON_PATH,
  "section.gambling.slotmachine.highlimit": DEFAULT_ICON_PATH,
  "section.gatearea": DEFAULT_ICON_PATH,
  "section.gatearea.holding": DEFAULT_ICON_PATH,
  "section.immigration": DEFAULT_ICON_PATH,
  "section.immigration.schengen": DEFAULT_ICON_PATH,
  "section.information": sharedIconPaths["information"],
  "section.paidarea": DEFAULT_ICON_PATH,
  "section.parkandride": DEFAULT_ICON_PATH,
  "section.parking": sharedIconPaths["parking"],
  "section.parking.bicycle": sharedIconPaths["parking.bicycle"],
  "section.parking.compact": sharedIconPaths["parking.compact"],
  "section.parking.ev": sharedIconPaths["parking.ev"],
  "section.parking.longterm": sharedIconPaths["parking.longterm"],
  "section.parking.motorcycle": sharedIconPaths["parking.motorcycle"],
  "section.parking.shortterm": sharedIconPaths["parking.shortterm"],
  "section.parking.waitingarea": sharedIconPaths["parking.waitingarea"],
  "section.platform": DEFAULT_ICON_PATH,
  "section.postsecurity": DEFAULT_ICON_PATH,
  "section.presecurity": DEFAULT_ICON_PATH,
  "section.private": DEFAULT_ICON_PATH,
  "section.recomposearea": DEFAULT_ICON_PATH,
  "section.recreation": sharedIconPaths["recreation"],
  "section.rental": DEFAULT_ICON_PATH,
  "section.retail": DEFAULT_ICON_PATH,
  "section.retaildepartment": DEFAULT_ICON_PATH,
  "section.road": DEFAULT_ICON_PATH,
  "section.seating": sharedIconPaths["seating"],
  "section.seatingrow": DEFAULT_ICON_PATH,
  "section.security": sharedIconPaths["security"],
  "section.servicearea": DEFAULT_ICON_PATH,
  "section.ticketing": sharedIconPaths["ticketing"],
  "section.vegetation": DEFAULT_ICON_PATH,
  "section.walkway": DEFAULT_ICON_PATH,
  "section.unspecified": DEFAULT_ICON_PATH,
}
